<template>
    <b-overlay
        :show="showOverlay"
        rounded="sm"
        spinner-variant="primary"
        spinner-small
    >
        <b-row>
            <b-col>
                <b-form-group
                    :label="$t('Component(Label):name')"
                    label-for="name"
                >
                    <vue-autosuggest
                        ref="autocomplete"
                        :suggestions="suggestions"
                        :input-props="inputProps"
                        :get-suggestion-value="getSuggestionValue"
                        @selected="onSuggestionSelect"
                        @input="searchProducts"
                    >
                        <div slot-scope="{suggestion}">
                            {{suggestion.item.title}}
                        </div>
                    </vue-autosuggest>
                    <small class="text-danger" v-if="hasValidationError">{{ $t('Component(Label):name') }} field is required</small>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="text-right">
                <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="primary"
                    @click="add"
                >
                    Add
                </b-button>
            </b-col>
        </b-row>
    </b-overlay>
</template>

<script>
import { BRow, BCol, BButton, BFormGroup, BOverlay } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { VueAutosuggest } from 'vue-autosuggest'
import {ProductApi} from "@core/api";
import {ProductNames, ProductType} from "@/libs/product";
import {ProductProvider} from "@core/domain/product";

export default {
    directives: {Ripple,},
    components: {
        BRow, BCol, BButton, BFormGroup, VueAutosuggest, BOverlay
    },
    data() {
        return {
            name: null,

            product: null,
            showOverlay: false,

            suggestions: [],
            inputProps: {
                id: 'autosuggest__input_ajax',
                placeholder: this.$t('Component(ProductCategorySelect):search-placeholder'),
                class: 'form-control w-100',
                name: 'ajax',
            },
            hasValidationError: false,
            searchTimer: null,
        };
    },
    methods: {
        searchProducts(nameOrQueryString) {
            this.name = nameOrQueryString;
            this.product = null;

            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
            this.searchTimer = setTimeout(() => {
                ProductApi.searchIncludedProducts(nameOrQueryString).then((r) => {
                    this.suggestions = [{data: r.data}];
                });
            }, 600);
        },
        getSuggestionValue(suggestion) {
            return suggestion.item.title;
        },
        onSuggestionSelect(suggestion) {
            this.product = suggestion.item;
            this.name = this.product.title;
        },
        add() {
            if (this.product) {
                this.$emit('created', this.product);
            } else {
                if (!this.name) {
                    this.hasValidationError = true;
                } else {
                    this.hasValidationError = false;
                    this.showOverlay = true;
                    //  todo move to another standalone layer
                    ProductApi.add({
                        type: ProductType.OWN,
                        names: [{
                            key: ProductNames.SCIP_NAME,
                            value: this.name
                        }],
                        identifiers: []
                    }).then(r => {
                        return ProductProvider(r.data.id).getCard();
                    }).then(product => {
                        this.$emit('created', product);
                    }).finally(() => {
                        this.showOverlay = false;
                    });
                }
            }
        }
    },
}
</script>
